import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import HomeMainPage from "./HomeMainPage";
import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import {
  hasSeenCreditsModal,
  setHasSeenLowCreditAlert,
  showLowCreditModal,
} from "../actions/creditActions";
import CongratulationDialog from "../dialogs/CongratulationDialog";
import CreditAlertDialog from "../dialogs/CreditAlertDialog";
import { markModalSeenApi } from "../services/api/authApi";
const HomePage = () => {
  const dispatch = useDispatch();
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const { credits, hasSeenLowCreditAlert, isCreditsInitialized } = useSelector(
    (state) => state.credit
  );

  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    if (isCreditsInitialized) {
      if (credits < 10 && !hasSeenLowCreditAlert) {
        dispatch(showLowCreditModal(true));
      } else if (credits >= 10) {
        dispatch(setHasSeenLowCreditAlert(false));
      }
    }
  }, [credits, hasSeenLowCreditAlert, isCreditsInitialized, dispatch]);
  // Fetch `hasSeenModal` from Redux state
  const hasSeenModal = useSelector((state) => state.credit?.hasSeenCreditModal);
  useEffect(() => {
    if (!hasSeenModal) {
      setOpenModal(true);
    }
  }, []); // Include dependencies

  const handleClose = async () => {
    setOpenModal(false);
    try {
      const response = await markModalSeenApi(userInfo._id);

      if (response.status !== 200) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = response.data;

      if (data.hasSeenModal !== undefined) {
        dispatch(hasSeenCreditsModal(data.hasSeenModal)); // Dispatch action with the modal status
      }
    } catch (error) {
      console.error("Failed to update modal seen status", error);
    }
  };

  return userInfo ? (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flex: 1,
          overflow: "hidden",
        }}
      >
        <HomeMainPage />
      </Box>
      <CongratulationDialog
        // open={openModal}  // Originally set to true upon openModal
        open={false} // Temporarily set to false for beta launch
        onClose={handleClose}
      />
      {/* <CreditAlertModal /> */}
    </Box>
  ) : (
    <Navigate to="/" />
  );
};

export default HomePage;
